import Row from "@Containers/components/Row";
import FilterSectionTitle from "@SearchResults/features/sidebar/components/FilterSectionTitle";
import IconChevron from "@Icons/chevrons/IconChevron";
import React from "react";
import {ArrayFilterState} from "@SearchResults/reducers/filterSlice";

interface FilterToggleableSectionTitleProps {
    translationKey: string,
    filterDataKey?: keyof ArrayFilterState,
    opened: boolean,
}

function FilterToggleableSectionTitle({translationKey, filterDataKey, opened}: FilterToggleableSectionTitleProps) {
    return (
        <Row justify>
            <FilterSectionTitle
                filterDataKey={filterDataKey}
                translationKey={translationKey}
            />
            <IconChevron
                chevronOrientation={opened ? "up" : "down"}
                rotationAxis="X"
            />
        </Row>
    )
}

export default FilterToggleableSectionTitle